import { Injectable, inject } from '@angular/core';
import { calculatePathScore } from '@functions';
import { BoxDetection } from '@models';
import { MetricsService, SimulationService } from '@services';
import { SceneStore } from '@stores';
import { metrics } from './metrics';

@Injectable({
  providedIn: 'root',
})
export class ExtraCorporealKnotMetricsService {
  private metricsService = inject(MetricsService);
  private sceneStore = inject(SceneStore);
  private simulationService = inject(SimulationService);

  metrics = metrics;

  trackLeftTool(tool: BoxDetection) {
    this.metricsService.trackTool(tool, 'leftTool');
  }

  trackRightTool(tool: BoxDetection) {
    this.metricsService.trackTool(tool, 'rightTool');
  }

  finalizeMetrics() {
    this.metrics.time.value = this.simulationService.recordingTime();
    this.metrics.needleDriverLeftPath.value = calculatePathScore({
      maxScore: 15,
      minValue: 70,
      maxValue: 110,
      value: this.metricsService.getToolDistance('leftTool'),
    });
    this.metrics.needleDriverRightPath.value = calculatePathScore({
      maxScore: 15,
      minValue: 60,
      maxValue: 110,
      value: this.metricsService.getToolDistance('rightTool'),
    });

    this.sceneStore.updateMetrics(Object.values(this.metrics));
  }
}
